module.exports = __webpack_public_path__ + "static/media/office-gov.a0d34ff0.png";